import * as React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

type Breakpoint = keyof typeof BREAKPOINTS;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  inline?: boolean;
  breakpoint: Breakpoint;
}

function Breakpoint({
  breakpoint,
  inline,
  children,
  style = {},
  ...delegated
}: Props) {
  return (
    <Wrapper
      as={inline ? 'span' : 'div'}
      data-breakpoint={breakpoint}
      style={{
        '--display': inline ? 'inline' : 'block',
        ...style,
      }}
      {...delegated}
    >
      {children}
    </Wrapper>
  );
}

const breakpointsString = Object.keys(BREAKPOINTS)
  .map((bp) => {
    // Stupid TS...
    const breakpoint = bp as Breakpoint;

    return `
  &[data-breakpoint='${breakpoint}'] {
    @media ${BREAKPOINTS[breakpoint]} {
      display: var(--display, block);
    }
  }
`;
  })
  .join('');

const Wrapper = styled.div`
  display: none;

  ${breakpointsString}
`;

export default Breakpoint;
